import { Component, Input } from '@angular/core';
import { Product } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../components/toaster/toaster.model';

@Component({
  selector: 'product-cross-reference-table',
  templateUrl: './product-cross-reference-table.component.html',
  styleUrl: './product-cross-reference-table.component.scss',
  standalone: false,
})
export class ProductCrossReferenceTableComponent {
  @Input() PCRList!: Partial<Product>[];
  @Input() isSearched!: Observable<boolean>;

  constructor(private toasterService: ToasterService) {}

  noReference() {
    this.toasterService.closeALL();

    this.toasterService.init({
      type: TOASTER_TYPE.WARNING,
      content: 'No substitute products were found for the product.',
    });
  }
}
